/** Enable orders to be shipped to an access point */
export const ACCESS_POINT_SEARCH = 'Access Point Search';

/** Display an address disclaimer on the address form during checkout. */
export const ADDRESS_DISCLAIMER = 'Address Disclaimer';

/** Display address line 3(used for company name) first on the in checkout (order confirmation/review). */
export const ADDRESS_LINE_3_FIRST = 'Address Line 3 First';

/** Fetch address suggestions during checkout. */
export const ADDRESS_SUGGESTION = 'Address Suggestion';

/** Display return policy during checkout. */
export const DISPLAY_RETURN_POLICY = 'Display Return Policy';

/** Enable Pay With Cash as a supported payment method */
export const PAY_WITH_CASH = 'Pay With Cash';

/** Indicates shipping to PO Boxes is not supported. */
export const PO_BOX_BLOCKED = 'PO Box Blocked';

/** Check for potential PO Box addresses inputted during checkout. */
export const PO_BOX_CHECK = 'PO Box Check';

/** Display a shipping disclaimer when rendering shipping methods. */
export const SHIPPING_DISCLAIMER = 'Shipping Disclaimer';

/** Order updates via SMS */
export const SMS = 'SMS';

/** Sustainability messaging. */
export const SUSTAINABILITY = 'Sustainability';

/** Available features by store. Keep in sync with typescript/constants/features.ts. */
export default {
  AU: [
    ADDRESS_DISCLAIMER,
    ADDRESS_LINE_3_FIRST,
    ADDRESS_SUGGESTION,
    SMS,
    SUSTAINABILITY,
  ],
  CA: [
    ADDRESS_LINE_3_FIRST,
    ADDRESS_SUGGESTION,
    PO_BOX_BLOCKED, // SHOP-7847: temporary while there is a strike at Canada Post
    PO_BOX_CHECK,
    SMS,
    SUSTAINABILITY,
  ],
  ES: [
    ACCESS_POINT_SEARCH,
    ADDRESS_DISCLAIMER,
    ADDRESS_LINE_3_FIRST,
    ADDRESS_SUGGESTION,
    PO_BOX_BLOCKED,
    PO_BOX_CHECK,
    SHIPPING_DISCLAIMER,
    SMS,
    SUSTAINABILITY,
  ],
  FR: [
    ACCESS_POINT_SEARCH,
    ADDRESS_DISCLAIMER,
    ADDRESS_LINE_3_FIRST,
    ADDRESS_SUGGESTION,
    PO_BOX_BLOCKED,
    PO_BOX_CHECK,
    SHIPPING_DISCLAIMER,
    SMS,
    SUSTAINABILITY,
  ],
  GB: [
    ADDRESS_LINE_3_FIRST,
    ADDRESS_SUGGESTION,
    PO_BOX_BLOCKED,
    PO_BOX_CHECK,
    SUSTAINABILITY,
  ],
  IE: [
    ADDRESS_LINE_3_FIRST,
    ACCESS_POINT_SEARCH,
    ADDRESS_SUGGESTION,
    PO_BOX_BLOCKED,
    PO_BOX_CHECK,
    SUSTAINABILITY,
  ],
  JP: [ADDRESS_LINE_3_FIRST, SUSTAINABILITY],
  US: [
    ADDRESS_LINE_3_FIRST,
    ADDRESS_SUGGESTION,
    DISPLAY_RETURN_POLICY,
    PAY_WITH_CASH,
    PO_BOX_CHECK,
    SMS,
    SUSTAINABILITY,
  ],
};
